import { useEffect, useState } from "react";
import Footer from "../components/body/Footer";
import Header from "../components/body/Header";
import Entradas from "../page/Entradas";
import apiAntesala from "../../config/ConfigPublic";
import { FullMonth } from "../utils/FullMonth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import { useCleanupLocalStorage } from "../hooks/useCleanupLocalStorage";

const EntradasController = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Limpiar localStorage "entradas" al estar en listado de Entradas
  useCleanupLocalStorage();
  const [geolocation, setGeolocation] = useState(
    localStorage.getItem("geolocation")
  );
  const getParams = new URLSearchParams(location.search);
  const [filter, setFilter] = useState({
    //["filter[provincia]"]: geolocation ?? '',
    ["filter[fecha]"]: format(new Date(), "yyyy-MM-dd").toString(), //FullMonth(new Date()),
    sort: "fechas.fecha",
    per_page: 50,
  });
  const [provincias, setProvincias] = useState(null);
  const [categorias, setCategorias] = useState(null);
  const [eventos, setEventos] = useState(null);
  const [salas, setSalas] = useState({ data: null });
  const sorts = [
    {
      name: "Menor precio",
      sort: "entradas.precio",
    },
    {
      name: "Mayor precio",
      sort: "-entradas.precio",
    },
    {
      name: "Fecha mas reciente",
      sort: "-fechas.fecha",
    },
  ];

  const next = (perPage) => {
      let params = {
        ...filter,
        per_page: perPage + 50
      }
      fetch(setEventos, params, "/eventos");
  }

  const fetch = async (setData, params, url) => {
    const response = await apiAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!eventos) {
      let params = filter;

      if(getParams.get("search")){
        params= {...params, ['filter[nombre]']: getParams.get("search")}
      }

      if(getParams.get("filter[fecha]")){
        params= {...params, ['filter[fecha]']: getParams.get("filter[fecha]")}
      }

      if(getParams.get("provincia")){
        params= {...params, ['filter[provincia]']: getParams.get("provincia")}
      }


      setFilter({...params})
       fetch(setEventos, params, "/eventos");
    }
  }, []);

  useEffect(() => {
    if (!categorias) {
       fetch(setCategorias, {}, "/categorias");
    }
  }, []);

  useEffect(() => {
    if (!provincias) {
       fetch(setProvincias, {}, "/provincias");
    }
  }, []);
  return (
    <div className="container-fluid px-0 "  style={{background: "#fff"}}>
      <div className="w-100 shadow-sm mb-1 fixed-top bg-white">
        <Header discount={false} />
      </div>

      <div className="container-md min-vh-100">
        <Entradas
          provincias={provincias ?? []}
          data={eventos ?? { data: null }}
          setFilter={setFilter}
          filter={filter}
          sorts={sorts}
          fetch={fetch}
          setEventos={setEventos}
          setSalas={setSalas}
          salas={salas}
          categorias={categorias}
          navigate={navigate}
          next={next}
        />
      </div>
      <div className="w-100 container-fluid px-0 mx-0">
        <Footer />
      </div>
    </div>
  );
};

export default EntradasController;
